import axios from 'axios';
import config from '../config';
import ChromeServices from './ChromeServices';
let networkStatus: any = undefined;


const HEADER_ENAEP = {
  'Content-Type': 'application/json', 
  Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
}

const PUT_HEADER = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/json',  
}
const PUT_HEADER_NCS = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/octet-stream',  
}
export const put = (url: string, payload:any, timeout?:number,onProgress?:(bytes:number)=>void) => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.put<any>(
        url,
        payload,
        {
          onUploadProgress: progressEvent => !onProgress ?  console.log("On Upload Progresss",url,progressEvent.loaded) : onProgress(progressEvent.loaded),
          timeout:timeout || 40000,
          headers: config.getDeliveryMode() === 'ncs' ? PUT_HEADER_NCS : PUT_HEADER,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        },
      );
      console.log(`[NetworkService][put request][response][url: ${url} response: ${status}]`);

      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[NetworkService][put request][axios error][url: ${url} response: ${err}]`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[NetworkService][put request][axios unexpected error][url: ${url} response: ${err}]`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
}
export const  getResource =async (urlStr : string,timeout?:number) : Promise<any> => {
  const response = await axios.get<any>(
    urlStr,  
    {
      params: {
        t: new Date().getTime()
      },
      onDownloadProgress:progressEvent => console.log("on Dowload progress",progressEvent.loaded),
      timeout: timeout || 180000,
      headers: {
        Accept: 'application/json'
      },
    },
  )
  return response
}

export const  getResourceDownloadProgress =async (urlStr : string,timeout?:number,onProgress?:(bytes:number)=>void) : Promise<any> => {
  return new Promise(async function (resolve, reject) {
    let progress = 0;
    const onProgressEvent=(bytes:number)=>{
       progress =bytes;
       if(onProgress) onProgress(bytes)
    }
    try {
      const response = await axios.get<any>(
        urlStr,  
        {
          params: {
            t: new Date().getTime()
          },
          onDownloadProgress:progressEvent => onProgress ? onProgressEvent(progressEvent.loaded): console.log("On Downlod progress",progressEvent.loaded),
          timeout: timeout || 180000,
          headers: {
            Accept: 'application/json'
          },
        },
      )
      resolve(response)
    }
    catch(e){
      reject({progress: progress, error: e})
    }
    
  })
}

export const get = (url: string, timeout?: number):Promise<any> => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.get<any>(
        url,
        {
          timeout:timeout || 40000,
          headers: {
            Accept: 'application/json'
          },
        },
      );

      //console.log(JSON.stringify(data, null, 4));

      // 👇️ "response status is: 200"
      console.log(`[NetworkService][get request][response][url: ${url} response: ${status}]`);

      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[NetworkService][get request][axios error][url: ${url} response: ${err}]`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[NetworkService][get request][axios unexpected error][url: ${url} response: ${err}]`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
}
export const post = (url: string, payload:any,timeout?:number):Promise<any> => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.post<any>(
        url,
        payload,
        {
          timeout:timeout || 10000,
          headers: HEADER_ENAEP
        },
      );
      console.log(`[NetworkService][post request][response][url: ${url} response: ${status}]`);
        
      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[NetworkService][post request][axios error][url: ${url} response: ${err}]`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[NetworkService][post request][axios unexpected error][url: ${url} response: ${err}]`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
}
const NetworkService = {
  getNetworkStatusByIP:(ipAddress:{ipv4:string,macAddress:string})=>{
    if(ipAddress && ipAddress.ipv4){
      console.log(`[NetworkService][network status]`, ipAddress);
      //naep router range 192.168.15.xxx
      config.setLocalIPAddress(ipAddress.ipv4);
      if(ipAddress.ipv4.indexOf("192.168.15") > -1){
        return "router"
      }
      else {
        console.log(`[NetworkService][get network status][window.navigator.onLine][${window.navigator.onLine}]`);
       return  NetworkService.isDeviceOnline();
      }
    }
    else {
      return NetworkService.isDeviceOnline();
    }
  },
  init: (cb: any) => {
    console.log("NetworkService] init called");
    const resolveNetworkType = ()=>{
      console.log('NetworkService] isExtensionAvailable',ChromeServices.isExtensionAvailable());
      console.log(`[NetworkService][get network status][window.navigator.onLine][${window.navigator.onLine}]`);
      if(window.navigator.onLine){
        if(ChromeServices.isExtensionAvailable()){
          //network details only available on managed ChromeOS devices
          ChromeServices.sub.networkDetails().then((e: any)=>{
            console.log(`[NetworkService] ${JSON.stringify(e)}`);
            const currentConnection = NetworkService.getNetworkStatusByIP(e);
            console.log(`[NetworkService] current connecton ${currentConnection}`);
            config.setCurrentNetworkConnectionType(currentConnection);
            cb(currentConnection);
          }).catch(()=>{
            const onlineStatus = config.getOnlineStatus();
            cb(onlineStatus);
          });
        }
        else {
          //NetworkService.getNetworkStatus(cb, true);
        config.setCurrentNetworkConnectionType(NetworkService.isDeviceOnline());
         cb(NetworkService.isDeviceOnline());
        }
      }
     else {
       config.setCurrentNetworkConnectionType("offline");
       cb("offline");
     }
    };
    // @ts-ignore
    console.log(`[NetworkService][network status][type:${navigator.connection.effectiveType}]`);

    // @ts-ignore
    navigator.connection.addEventListener('change', function () {
      // @ts-ignore
      console.log(`[NetworkService][network status changed from ${networkStatus}][type:${navigator.connection.effectiveType}]`);
      resolveNetworkType();
    
    });
  },
  isDeviceOnline:()=>{
    //In airplane mode it returns true
    if(window.navigator.onLine){
      return "internet";
    }
    else {
      return "offline";
    }
  },
  getNetworkStatus: (cb: any, statusChange?: boolean) => {
    const _onlineStatus = () => {
      console.log(`[NetworkService][get network status][validating internet access]`);
      const getIP = get(config.getOnlineAPI().healthUrl);
      getIP.then((data) => {
        console.log(`[NetworkService][get network status][device is online and has internet access]`);
        networkStatus = "internet";
        cb("internet");
      }).catch(() => {
        console.log(`[NetworkService][get network status][device is online without internet access]`);
        networkStatus = "router";
        cb("router");
      })
    }
    console.log(`[NetworkService][get network status][window.navigator.onLine][${window.navigator.onLine}]`);
    //window.navigator.onLine takes time to detect the online status; how to skip validation on network change?
    if(statusChange){
      //check if device is online
      if (window.navigator.onLine) {
        //avoids multiple validations on stable network connection.
        _onlineStatus();
      }
      else {
        console.log(`[NetworkService][get network status] [device is offline without internet access]`);
        networkStatus = "offline";
        cb("offline");
      }
    }
    else {
      cb(networkStatus);
    }
   
    
    //TODO - if initial network status and server passed, check for server only
    
    

  },
  //Establish the handshake with Server via ncs.local domain
  //Server will return the IP
  getServerStatus: (cb: (status: boolean) => void, url: string, switchDomain?:boolean) => {
    const response = get(url);
    console.log(`[NetworkService][get server status][NPD service availabiity][launch mode: ${config.getDeliveryMode()}]`);
    response.then((response: any) => {
      console.log(`[NetworkService][get server status][NPD services available: ${JSON.stringify(response)}]`);
      if(config.getDeliveryMode() === "ncs"){
        console.log("NCS IP address", response.data?.data?.connectionInfo?.ipAddress);
        config.setNCSDetails(response.data?.data?.connectionInfo);
        
        //config.setNCSDomain(response.data?.data?.connectionInfo?.ipAddress)
        if(switchDomain){
          config.setNCSDomain(response.data?.data?.connectionInfo?.ipAddress);
        }
        else {
          config.setNCSDomain("ncs.local"); 
        }
      }
      cb(response.status === 200 ? true : false);
    }).catch((e) => {
      console.error(`[NetworkService][get server status][NPD services not available: ${JSON.stringify(e)}`);
      cb(false)
    })

  },
  //Validate if server can be accessed via IP if not fallback to ncs.local
  getNCSServerStatusByIP: (cb: (status: boolean) => void, url: string) => {
    console.log("[NetworkService] call health check using IP", url);
    const response = get(url);
    response.then((response: any) => {
      console.log(`[NetworkService][get server status][NPD services available: ${JSON.stringify(response)}]`);
      if(config.getDeliveryMode() === "ncs"){
        console.log("NCS IP address", response.data?.data?.connectionInfo?.ipAddress)
        //config.setNCSDomain(response.data?.data?.connectionInfo?.ipAddress)
        config.setNCSDomain(response.data?.data?.connectionInfo?.ipAddress);
      }
      if(response.status !== 200){
        config.setNCSDomain("ncs.local");
      }
      cb(true);
    }).catch((e) => {
      console.error(`[NetworkService][get server status][Server is not reachable: ${JSON.stringify(e)}`);
      config.setNCSDomain("ncs.local");
      cb(false)
    })

  }
}



export default NetworkService;
